import Api from "./Api";

export default {
  createConversation(payload) {
    return Api().post(`proxy/ai/company/${payload.companyId}/v2/conversations`, payload);
  },
  getHistoryOfConversation(payload) {
    return Api().get(`proxy/ai/company/${payload.companyId}/conversations/${payload.conversation_uuid}/v2/messages`, { params: payload.params });
  },
  getAllConversations(payload) {
    return Api().get(`proxy/ai/company/${payload.companyId}/conversations`, { params: payload.params });
  },
  getLiveKitToken(payload) {
    return Api().post(`proxy/ai/api/livekit/getToken`, payload);
  },
};
